import Joi from "joi";

const createPainEntryFormSchema = Joi.object({
  // Required fields with custom error messages
  painTypes: Joi.array().items(Joi.string()).min(1).required().messages({
    "array.min": "At least one pain type must be selected.",
    "any.required": "Pain types are required.",
  }),
  painDuration: Joi.string().required().trim().min(1).messages({
    "string.empty": "Pain duration is required.", // Custom message when it's an empty string
    "any.required": "Pain duration is required.",
  }),
  painLocations: Joi.array().items(Joi.string()).min(1).required().messages({
    "array.min":
      "You Should At least mark one location of the pain at your body",
    "any.required":
      "You Should At least mark one location of the pain at your body",
  }),
  reliefMethods: Joi.array().items(Joi.string()).min(1).required().messages({
    "array.min": "At least one relief method must be selected.",
    "any.required": "Relief methods are required.",
  }),
  reliefEffectiveness: Joi.string().required().trim().min(1).messages({
    "string.empty": "Relief effectiveness is required.",
    "any.required": "Relief effectiveness is required.",
  }),
  showNotes: Joi.boolean().optional(),

  notes: Joi.when("showNotes", {
    is: true, // When showNotes is true
    then: Joi.string().required().trim().min(1).messages({
      "string.empty": "Note are required..",
      "any.required": "Note are required..",
    }),
    otherwise: Joi.string().optional().allow("").trim().messages({
      "string.empty": "Note are required..",
    }),
  }),
  // Optional fields with custom error messages
  additionalDetailsClicked: Joi.boolean().optional().messages({
    "boolean.base": "Additional details clicked must be a boolean value.",
  }),
  energyLevel: Joi.string().optional().allow("").messages({
    "string.base": "Energy level must be a string.",
  }),
  symptoms: Joi.array().items(Joi.string()).optional().messages({
    "array.base": "Symptoms must be an array of strings.",
  }),
  symptomDuration: Joi.string().optional().allow("").messages({
    "string.base": "Symptom duration must be a string.",
  }),
  triggerTracking: Joi.array().items(Joi.string()).optional().messages({
    "array.base": "Trigger tracking must be an array of strings.",
  }),
  moodLevel: Joi.string().optional().allow("").messages({
    "string.base": "Mood level must be a string.",
  }),
}).unknown(true);

export const validatePainEntryForm = (data: IPainEntryFormSliceProp) => {
  const { error, value } = createPainEntryFormSchema.validate(data, {
    abortEarly: false,
  });
  if (error) {
    return {
      isError: true,
      errors: error.details.map((err) => err.message),
    };
  } else {
    return {
      isError: false,
      errors: [],
    };
  }
};
